import type { Business } from '../types';

interface BusinessListViewProps {
  businesses: Business[];
  selectedBusinesses: Set<number>;
  onSelectionChange: (id: number) => void;
}

export function BusinessListView({
  businesses,
  selectedBusinesses,
  onSelectionChange,
}: BusinessListViewProps) {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-900 border-b border-slate-700">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider w-12">
                Select
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
                Business Name
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
                Address
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
                Phone
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
                Website
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-300 uppercase tracking-wider">
                Contact
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-700">
            {businesses.map((business) => (
              <tr
                key={business.id}
                className={`hover:bg-slate-750 transition-colors ${
                  selectedBusinesses.has(business.id) ? 'bg-slate-700' : ''
                }`}
              >
                <td className="px-4 py-4">
                  <input
                    type="checkbox"
                    checked={selectedBusinesses.has(business.id)}
                    onChange={() => onSelectionChange(business.id)}
                    className="h-4 w-4 rounded border-slate-600 bg-slate-700 text-blue-500 focus:ring-blue-500 focus:ring-offset-slate-800"
                  />
                </td>
                <td className="px-4 py-4">
                  <div className="flex items-center">
                    <div>
                      <div className="font-medium text-slate-100">{business.name}</div>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-4">
                  <div className="text-sm text-slate-300">{business.address}</div>
                </td>
                <td className="px-4 py-4">
                  <div className="text-sm text-slate-300">
                    {business.phone || '-'}
                  </div>
                </td>
                <td className="px-4 py-4">
                  {business.website ? (
                    <a
                      href={business.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-blue-400 hover:text-blue-300 underline"
                    >
                      Visit
                    </a>
                  ) : (
                    <span className="text-sm text-slate-500">-</span>
                  )}
                </td>
                <td className="px-4 py-4">
                  <div className="flex gap-2 text-sm">
                    {business.email && (
                      <a
                        href={`mailto:${business.email}`}
                        className="text-blue-400 hover:text-blue-300"
                        title="Email"
                      >
                        📧
                      </a>
                    )}
                    {business.instagram && (
                      <a
                        href={business.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-pink-400 hover:text-pink-300"
                        title="Instagram"
                      >
                        📷
                      </a>
                    )}
                    {business.facebook && (
                      <a
                        href={business.facebook}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-400 hover:text-blue-300"
                        title="Facebook"
                      >
                        👤
                      </a>
                    )}
                    {business.linkedin && (
                      <a
                        href={business.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-400"
                        title="LinkedIn"
                      >
                        💼
                      </a>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
